import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { ImproveNoteContent } from './ImproveNoteContent';
import { LightningIcon } from '@phosphor-icons/react';
import type { UseImproveNoteOptions } from '@/hooks/useImproveNote';

export interface ImproveNoteDialogProps {
  noteId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  options?: UseImproveNoteOptions;
}

export function ImproveNoteDialog({
  noteId,
  open,
  onOpenChange,
  options,
}: ImproveNoteDialogProps) {
  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-7xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <LightningIcon className="h-5 w-5" />
            AI Note Improvement
          </DialogTitle>
          <DialogDescription>
            Our AI will analyze your note and suggest improvements to make it
            more helpful and actionable.
          </DialogDescription>
        </DialogHeader>

        <ImproveNoteContent
          noteId={noteId}
          onClose={handleClose}
          options={options}
        />
      </DialogContent>
    </Dialog>
  );
}
